import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export const acceptOfferService = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
    authenticationData: AuthenticationData,
    offerId: string,
): Promise<void> => {
    await apiClient<void>(`${proxyBaseUrl}/offers/${arn}`, {
        method: 'PUT',
        body: { offerId },
        apiKey,
        authenticationData,
        responseType: 'void',
        sentryTag: 'accept_offer',
        sentryExtra: { arn },
    });
};
